import React from "react";
import { Avatar } from "@toddle-edu/ds-web";

const IconAvatar = props => {
  const {
    icon: Icon,
    size,
    color = "pink",
    dsVersion = "2.0",
    className,
  } = props;

  return (
    <Avatar
      icon={<Icon />}
      color={color}
      size={size}
      shape="square"
      theme="light"
      iconType="icon"
      dsVersion={dsVersion}
      className={className}
    />
  );
};

export default IconAvatar;
